import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=60ea8e93&scoped=true&"
import script from "./Todos.vue?vue&type=script&lang=js&"
export * from "./Todos.vue?vue&type=script&lang=js&"
import style0 from "./Todos.vue?vue&type=style&index=0&id=60ea8e93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea8e93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
